import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import LogoGallery from '../components/Gallery/LogoGallery'
import PrintGallery from '../components/Gallery/PrintGallery'
import WebGallery from '../components/Gallery/WebGallery'
import EcommerceGallery from '../components/Gallery/EcommerceGallery'
import MobileAppGallery from '../components/Gallery/MobileAppGallery'
import VideoGallery from '../components/Gallery/VideoGallery'

const PortfolioSection = () => {

    const [activeTab, setActiveTab] = useState('logo');
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };      

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    };

    return (
        <section className="service-one">
            <div className="container tabs-box">
                <div className="sec-title text-center">
                    <h3 className="sec-title__title">Work that speaks for it self</h3>
                </div>
                <ul className="list-unstyled tab-buttons service-one__tabs">
                    <li data-tab="#logo" onClick={() => handleTabClick('logo')} className={`tab-btn ${activeTab === 'logo' ? 'active-btn' : ''}`}>Logo</li>
                    <li data-tab="#print_media" onClick={() => handleTabClick('print_media')} className={`tab-btn ${activeTab === 'print_media' ? 'active-btn' : ''}`}>Print Media</li>
                    <li data-tab="#web_design_development" onClick={() => handleTabClick('web_design_development')} className={`tab-btn ${activeTab === 'web_design_development' ? 'active-btn' : ''}`}>Web Design & Development</li>
                    <li data-tab="#e_commerce" onClick={() => handleTabClick('e_commerce')} className={`tab-btn ${activeTab === 'e_commerce' ? 'active-btn' : ''}`}> E-commerce</li>
                    <li data-tab="#mobile_app" onClick={() => handleTabClick('mobile_app')} className={`tab-btn ${activeTab === 'mobile_app' ? 'active-btn' : ''}`}>Mobile App</li>
                    <li data-tab="#video" onClick={() => handleTabClick('video')} className={`tab-btn ${activeTab === 'video' ? 'active-btn' : ''}`}>Video</li>
               </ul>

                <div className="tabs-content">
                    <div className={`tab fadeInUp animated ${activeTab === 'logo' ? 'active-tab' : ''}`} id="logo">
                        <div className="photo-gallery">
                            {activeTab === "logo" && <LogoGallery />}
                        </div>
                    </div>
                    <div className={`tab fadeInUp animated ${activeTab === 'print_media' ? 'active-tab' : ''}`} id="print_media">
                        <div className="photo-gallery">
                             {activeTab === "print_media" && <PrintGallery />}
                        </div>
                    </div>
                    <div className={`tab fadeInUp animated ${activeTab === 'web_design_development' ? 'active-tab' : ''}`} id="web_design_development">
                        <div className="photo-gallery">
                            {activeTab === "web_design_development" && <WebGallery />}
                        </div>
                    </div>
                    <div className={`tab fadeInUp animated ${activeTab === 'e_commerce' ? 'active-tab' : ''}`} id="e_commerce">
                        <div className="photo-gallery">
                            {activeTab === "e_commerce" && <EcommerceGallery />}
                        </div>
                    </div>
                    <div className={`tab fadeInUp animated ${activeTab === 'mobile_app' ? 'active-tab' : ''}`} id="mobile_app">
                        <div className="photo-gallery">
                            {activeTab === "mobile_app" && <MobileAppGallery />}
                        </div>
                    </div>
                    <div className={`tab fadeInUp animated ${activeTab === 'video' ? 'active-tab' : ''}`} id="video">
                        <div className="photo-gallery">
                            {activeTab === "video" && <VideoGallery />}
                        </div>
                    </div>
                </div>   


            </div>  

            { isHomePage && 
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-md-12 mt-5 pt-5">
                            <div className="portfolio-one__item__btn text-center">
                                <Link className="growim-btn growim-btn--white" to="/portfolio" onClick={scrollToTop}>
                                    <span className="growim-btn__text">View All Portfolio</span>
                                    <span className="growim-btn__icon"><i className="flaticon-up-right-arrow"></i></span>
                                </Link>
                            </div>
                        </div> 
                    </div>
                </div>                 
            }


        </section>
    )
}

export default PortfolioSection